
<span class="tw-flex gd-ellipsis-label-tooltip-wrapper"
  [matTooltip]="tooltipLabel"
  matTooltipPosition="below"
  [matTooltipDisabled]="disableTooltip(tooltipLabel)">
    <span>
      <ng-content></ng-content>
    </span>
</span>
